import axios from 'axios';

import { getRequestCallback } from './getRequestCallback';
import { getResponseCallback } from './getResponseCallback';

export const apiClient = axios.create();

apiClient.interceptors.request.use(getRequestCallback());
apiClient.interceptors.response.use(getResponseCallback());
